export const UIExpirationsHelpers = (customSortedKeyMap) => {
    return {
        sortedKeyMap: customSortedKeyMap,
        defaultSorted: [{ dataField: 'pending_payment', order: 'desc' }],
        initialFilter: {
            filters: null,
            sortOrder: 'desc',
            sortField: 'pending_payment',
            pageNumber: 1,
            pageSize: localStorage.getItem('sizePerPage') || 10
        }
    };
};
